import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../Finanzas/Actions/GetContainer";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

// Filtro de Cotizaciones de Servicio — fecha inicio/fin + ADR/Sucursal en cascada, mismo
// patrón visual que los filtros de Reportes CRM (clases rca-*, compartidas entre pantallas).
export const FiltroCotizacionesServicio = ({ onCargar, boxState, onBoxChange, permisos }) => {
  const [openModal, setOpenModal] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [adr, setAdr] = useState([]);
  const [sucursal, setSucursal] = useState([]);

  const [filtro, setFiltro] = useState({
    fechaInicio: boxState.fechaInicio,
    fechaFin: boxState.fechaFin,
  });

  useEffect(() => {
    GetASD()
      .then((res) => {
        setRawData(res);
        setAdr(GroupByPropCheck(res, ["idadr", "adr"], false));
        setSucursal(GroupByPropCheck(res, ["idsucursal", "sucursal"], false));
        onBoxChange("pv", { adr: GroupByProps(res, ["idadr", "adr"]), sucursal: [] });
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Rol UREG solo ve/filtra su propia región y sucursales asignadas; REWR, ADCS, UCLD, UCLR y
  // UCLS ven todo.
  useEffect(() => {
    if (rawData.length === 0 || permisos?.usuariorol !== "UREG") return;

    const regionUsuario = String(permisos.regionusuario);
    const sucursalesPermitidas = permisos.sucursalesusuario
      ? permisos.sucursalesusuario.split(",").map((s) => s.trim())
      : [];

    const adrRestringido = GroupByPropCheck(rawData, ["idadr", "adr"], false)
      .filter((item) => String(item.idadr) === regionUsuario)
      .map((item) => ({ ...item, checked: true }));

    const sucursalRestringida = GroupByPropCheck(rawData, ["idsucursal", "sucursal"], false)
      .filter((item) => sucursalesPermitidas.includes(String(item.idsucursal)));

    setAdr(adrRestringido);
    setSucursal(sucursalRestringida);
    onBoxChange("pv", {
      adr: adrRestringido.map((a) => ({ idadr: a.idadr, adr: a.adr })),
      sucursal: [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawData, permisos]);

  const onOpenModal = () => {
    const container = document.getElementById("crmcsFiltroCotizacionesServicio-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onChange = ({ target }) => {
    setFiltro((prev) => ({ ...prev, [target.name]: target.value }));
  };

  const onAdrChange = (e, index) => {
    const updated = [...adr];
    updated[index].checked = e.target.checked;

    const activos = updated.filter((a) => a.checked);
    let nuevaSucursal = [];
    activos.forEach((a) => {
      nuevaSucursal = nuevaSucursal.concat(
        GroupByForeignKey(rawData, "idadr", a.idadr, ["idsucursal", "sucursal"])
      );
    });

    onBoxChange("pv", {
      adr: activos.map((a) => ({ idadr: a.idadr, adr: a.adr })),
      sucursal: [],
    });
    setAdr(updated);
    setSucursal(
      activos.length === 0
        ? GroupByPropCheck(rawData, ["idsucursal", "sucursal"], false)
        : GroupByPropCheck(nuevaSucursal, ["idsucursal", "sucursal"], false)
    );
  };

  const onSucursalChange = (e, index) => {
    const updated = [...sucursal];
    updated[index].checked = e.target.checked;
    setSucursal(updated);

    const sucursalActiva = updated
      .filter((s) => s.checked)
      .map((s) => ({ idsucursal: s.idsucursal, sucursal: s.sucursal }));
    onBoxChange("pv", { adr: boxState.pv.adr, sucursal: sucursalActiva });
  };

  const handleCargar = () => {
    onBoxChange("fechaInicio", filtro.fechaInicio);
    onBoxChange("fechaFin", filtro.fechaFin);
    onOpenModal();
    onCargar({ fechaInicio: filtro.fechaInicio, fechaFin: filtro.fechaFin });
  };

  return (
    <div className="rca-filtro">
      <button type="button" className="rca-filtro-btn" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </button>

      <div className="rca-filtro-modal" id="crmcsFiltroCotizacionesServicio-modal">
        <PlantillaScreen
          titulo="Filtro"
          className_main={1}
          className={`rca-filtro-modal-plantilla ${permisos?.usuariorol === "GESU" || permisos?.usuariorol === "VESC" || permisos?.usuariorol === "UCBA" ? "sinadr" : ""}`}
        >
          <div className="rca-filtro-modal-close" onClick={onOpenModal}>
            X
          </div>

          <div className="rca-filtro-modal-body">
            <div className="rca-filtro-modal-filtros">
              <div className="rca-filtro-tiempo">
                <div className="rca-filtro-group">
                  <label>Fecha Inicio</label>
                  <input
                    type="date"
                    name="fechaInicio"
                    value={filtro.fechaInicio}
                    onChange={onChange}
                    className="rca-filtro-date-input"
                  />
                  <label>Fecha Fin</label>
                  <input
                    type="date"
                    name="fechaFin"
                    value={filtro.fechaFin}
                    onChange={onChange}
                    className="rca-filtro-date-input"
                  />
                </div>
                <div className="rca-filtro-btn-cargar" onClick={handleCargar}>
                  Cargar
                </div>
              </div>

              {permisos?.usuariorol !== "GESU" && permisos?.usuariorol !== "VESC" && permisos?.usuariorol !== "UCBA" && (
                <>
                  <div className="rca-filtro-adr">
                    <div className="rca-filtro-title">Región</div>
                    {adr.map((item, index) => (
                      <div key={item.idadr} className="rca-chk-groups">
                        <input
                          type="checkbox"
                          name="chk-adr"
                          checked={item.checked}
                          value={item.idadr}
                          onChange={(e) => onAdrChange(e, index)}
                        />
                        <label>{capitalizePalabras(item.adr)}</label>
                      </div>
                    ))}
                  </div>

                  <div className="rca-filtro-sucursal">
                    <div className="rca-filtro-title">Sucursal</div>
                    {sucursal.map((item, index) => (
                      <div key={item.idsucursal} className="rca-chk-groups">
                        <input
                          type="checkbox"
                          name="chk-sucursal"
                          checked={item.checked}
                          value={item.idsucursal}
                          onChange={(e) => onSucursalChange(e, index)}
                        />
                        <label>{capitalizePalabras(item.sucursal)}</label>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
